import HardwareSerializer from 'eflex/serializers/hardware';

export default class CognexCameraSerializer extends HardwareSerializer {}
